import { Outlet, Navigate, NavLink, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Files, LogOut, Leaf, Mail, Sparkles } from "lucide-react";
import { useEffect } from "react";

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  if (user === null) {
    return <div className="p-10 text-neutral-500" data-testid="admin-loading">Loading…</div>;
  }
  if (user === false || user?.role !== "admin") {
    return <Navigate to="/admin/login" replace />;
  }

  return (
    <div className="min-h-screen bg-mist" data-testid="admin-shell">
      <aside className="fixed inset-y-0 left-0 w-[240px] bg-forest text-white/85 hidden lg:flex flex-col grain">
        <div className="p-5 flex items-center gap-2.5">
          <span className="grid place-items-center h-9 w-9 rounded-lg bg-white/10 text-white"><Leaf size={18}/></span>
          <div>
            <p className="font-heading font-semibold text-white text-[15px] leading-tight">Be Green Group</p>
            <p className="text-[11px] text-white/50">Operations</p>
          </div>
        </div>
        <nav className="mt-2 flex flex-col gap-1 px-3">
          <NavItem to="/admin" icon={LayoutDashboard} label="Dashboard" end />
          <NavItem to="/admin/applications" icon={Files} label="Applications" />
          <NavItem to="/admin/green-advisor" icon={Sparkles} label="Green Advisor" />
          <NavItem to="/admin/emails" icon={Mail} label="Email log" />
        </nav>
        <div className="mt-auto p-5 border-t border-white/10">
          <p className="text-[12px] text-white/50">Signed in as</p>
          <p className="text-[13px] font-semibold text-white truncate">{user.email}</p>
          <button
            onClick={async () => { await logout(); navigate("/admin/login"); }}
            data-testid="admin-logout"
            className="mt-4 inline-flex items-center gap-2 text-[13px] text-white/70 hover:text-white"
          >
            <LogOut size={14} /> Sign out
          </button>
        </div>
      </aside>
      <main className="lg:pl-[240px]">
        {/* mobile bar */}
        <div className="lg:hidden sticky top-0 z-10 bg-forest text-white flex items-center justify-between px-4 h-14">
          <div className="flex items-center gap-2"><Leaf size={16}/><span className="font-heading font-semibold text-[14px]">Be Green Admin</span></div>
          <button onClick={async () => { await logout(); navigate("/admin/login"); }} className="text-[13px] text-white/80" data-testid="admin-logout-mobile"><LogOut size={14}/></button>
        </div>
        <div className="container-x max-w-7xl mx-auto py-8 md:py-10">
          <Outlet />
        </div>
      </main>
    </div>
  );
}

function NavItem({ to, icon: Icon, label, end }) {
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) => `flex items-center gap-3 rounded-xl px-3 py-2.5 text-[14px] transition-colors ${
        isActive ? "bg-white/10 text-white" : "text-white/70 hover:text-white hover:bg-white/5"
      }`}
    >
      <Icon size={16} />
      {label}
    </NavLink>
  );
}
